export const dates = {
  order: {
    'days-months-years': 'D|M|Y',
    'years-days-months': 'Y|D|M',
    'months-days-years': 'M|D|Y',
    'months-years-days': 'M|Y|D',
    'years-months-days': 'Y|M|D',
  },
  formats: {
    MONTH: {
      '01-12': '01-12',
      '1-12': '1-12',
      'Jan-Dec': 'Jan-Dec',
      'January-December': 'January-December',
      None: 'None',
    },
    DAY: {
      '01-31': '01-31',
      '1-31': '1-31',
      None: 'None',
    },
    YEAR: {
      '0000-9999': '0000-9999',
      '00-99': '00-99',
      None: 'None',
    },
  },
} as const
